module.exports = __webpack_public_path__ + "static/circle_tag_shapyers-2683fde171ebee85c6806e233df27c33.png";